
export interface TeamData {
  id: string;
  name: string;
  logo: string;
  category: string;
  group?: string;
  isOwnTeam?: boolean;
  isOwn?: boolean;
  type?: string;
}

export const teams: TeamData[] = [
  // Equipos propios
  {
    id: '41deddf1-aaaa-49c8-be9f-e2f16d48f1a4',
    name: 'VIUBÀSQUET A',
    logo: '/media/logos/viubasquet.png',
    category: 'Liga Insular',
    group: 'Grup-3',
    isOwnTeam: true,
    isOwn: true,
    type: 'own'
  },
  {
    id: '7f087cc3-88ac-4faf-948d-1f7961891da0',
    name: 'VIUBÀSQUET B',
    logo: '/media/logos/viubasquet.png',
    category: 'Liga Insular',
    group: 'Grup-4',
    isOwnTeam: true,
    isOwn: true,
    type: 'own'
  },
  {
    id: '3bb74665-4363-4dbd-9b68-3779686b04dc',
    name: 'MINI',
    logo: '/media/logos/viubasquet.png',
    category: 'Mini',
    isOwnTeam: true,
    isOwn: true,
    type: 'own'
  },
  {
    id: 'c5e3e27d-4048-48fc-a47d-4aeb33e29514',
    name: 'PREMINI',
    logo: '/media/logos/viubasquet.png',
    category: 'Premini',
    isOwnTeam: true,
    isOwn: true,
    type: 'own'
  },

  // Equipos Liga Insular Grup-3
  {
    id: 'e52b4d36-658c-4123-837a-fd44a456ca9c',
    name: 'A8 IMMO CIUTAT D\'INCA BÀSQUET',
    logo: '/media/logos/inca.png',
    category: 'Insular',
    group: 'Grup-3',
    isOwnTeam: false
  },
  {
    id: 'c1534432-9503-4e5b-a5fb-8a0ed0dbc790',
    name: 'SA POBLA BC A MIQUEL SAMPOL TREBALLS D\'OBRA',
    logo: '/media/logos/sa_pobla.png',
    category: 'Insular',
    group: 'Grup-3',
    isOwnTeam: false
  },
  {
    id: 'a884de68-cc99-4f1c-9dfd-448e8bd3dbfa',
    name: 'CB BINISSALEM ROSA - FORN NOU B',
    logo: '/media/logos/binissalem.png',
    category: 'Insular',
    group: 'Grup-3',
    isOwnTeam: false
  },
  {
    id: '2baedd86-5514-4f4a-a86c-4b4f98974548',
    name: 'BASQUET ARTA',
    logo: '/media/logos/arta.png',
    category: 'Insular',
    group: 'Grup-3',
    isOwnTeam: false
  },
  {
    id: 'fa46b0c6-f989-4378-abec-ffe2ea2dd49d',
    name: 'SANT FRANCESC LLOPS D\'INCA B INMOBILIARIA SA MARINA',
    logo: '/media/logos/llops.png',
    category: 'Insular',
    group: 'Grup-3',
    isOwnTeam: false
  },

  // Equipos Liga Insular Grup-4
  {
    id: 'ef71161c-34ba-4d93-ae9a-bb5ace93b9d6',
    name: 'CB CIDE CONSTRUCCIONS JAM SOLLER JOVENTUT MARIANA',
    logo: '/media/logos/cide.png',
    category: 'Insular',
    group: 'Grup-4',
    isOwnTeam: false
  },
  {
    id: 'f0af9008-b826-4291-b751-7eef3a96b6a7',
    name: 'ESPORLES BC',
    logo: '/media/logos/esporles.png',
    category: 'Insular',
    group: 'Grup-4',
    isOwnTeam: false
  },
  {
    id: '8df129bb-9f60-4926-9914-6447b507ebbf',
    name: 'CLUB BASQUET PLA',
    logo: '/media/logos/pla.png',
    category: 'Insular',
    group: 'Grup-4',
    isOwnTeam: false
  },
  {
    id: '5125b2a8-e24a-462c-b811-e19d84d0f587',
    name: 'SA CABANETA B FORN STO CRISTO',
    logo: '/media/logos/sa_cabaneta.png',
    category: 'Insular',
    group: 'Grup-4',
    isOwnTeam: false
  },

  // Equipos Categoría Mini
  {
    id: '036a5d32-14e3-4c95-ba73-1f377750650d',
    name: 'SA CABANETA NEGRE B ES MERCA',
    logo: '/media/logos/sa_cabaneta.png',
    category: 'Mini',
    isOwnTeam: false
  },
  {
    id: '9d432933-71dd-414f-b27b-5df424f4a9b5',
    name: 'SAN CAYETANO BLANCO B',
    logo: '/media/logos/san_cayetano.png',
    category: 'Mini',
    isOwnTeam: false
  },
  {
    id: '12ec1e8d-539e-48ce-93e4-6b6a4600527b',
    name: 'BÀSQUET CALVIÀ B DURAN',
    logo: '/media/logos/calvia.png',
    category: 'Mini',
    isOwnTeam: false
  },
  {
    id: '80caec8a-955a-4785-af70-6189d3f8ae0e',
    name: 'CB CIDE B SA INDIOTERIA',
    logo: '/media/logos/cide.png',
    category: 'Mini',
    isOwnTeam: false
  },
  {
    id: 'a371179e-33f2-4729-b4b4-1e30a3a1f387',
    name: 'SA INDIOTERIA',
    logo: '/media/logos/indiotieria.png',
    category: 'Mini',
    isOwnTeam: false
  },
  {
    id: 'ab214976-f64c-4039-81e7-34788137bac1',
    name: 'ESPORLES BC B TERRITORI VERDESCA',
    logo: '/media/logos/esporles.png',
    category: 'Mini',
    isOwnTeam: false
  },
  {
    id: 'e8bcbb4b-cfe6-48cd-86da-7bd6093d9be0',
    name: 'MOLINAR MIXTO B',
    logo: '/media/logos/molinar.png',
    category: 'Mini',
    isOwnTeam: false
  },
  {
    id: '1e6bf8b2-2097-42b7-9d01-61fadc2dbfd6',
    name: 'UADIS B',
    logo: '/media/logos/sant_josep.png',
    category: 'Mini',
    isOwnTeam: false
  },
  {
    id: 'f728d0e6-9db3-4001-8c9e-9ed4b7166ade',
    name: 'SCD HISPANIA SANT PERE B',
    logo: '/media/logos/hispania.png',
    category: 'Mini',
    isOwnTeam: false
  },
  {
    id: 'fa169757-ec8a-417a-a0f1-8bdf73f8a1c7',
    name: 'CLUB BASQUET PLA B',
    logo: '/media/logos/pla.png',
    category: 'Mini',
    isOwnTeam: false
  },
  {
    id: '85961a85-4b4e-4331-b46c-37fec62abed6',
    name: 'CB IMPRENTA BAHIA SAN AGUSTIN C',
    logo: '/media/logos/bahia.png',
    category: 'Mini',
    isOwnTeam: false
  },

  // Equipos Categoría Premini
  {
    id: '536e9d69-e83b-42d5-aa39-87f0f3e867eb',
    name: 'SA CABANETA MASCULÍ',
    logo: '/media/logos/sa_cabaneta.png',
    category: 'Premini',
    isOwnTeam: false
  },
  {
    id: '9ee688ac-fba6-40be-8f75-72e7b7177c46',
    name: 'CLUB BASQUET PLA MASCULÍ',
    logo: '/media/logos/pla.png',
    category: 'Premini',
    isOwnTeam: false
  },
  {
    id: '523490ba-a133-4eb9-9f4a-595845830e5e',
    name: 'CD MADRE ALBERTA A',
    logo: '/media/logos/madre_alberta.png',
    category: 'Premini',
    isOwnTeam: false
  },
  {
    id: '7b356de2-3fe6-4635-ab2d-5e2d804b2720',
    name: 'ESPORLES BC NEGRE A',
    logo: '/media/logos/esporles.png',
    category: 'Premini',
    isOwnTeam: false
  },
  {
    id: 'c8cffad2-f382-4359-a418-198d71cb4007',
    name: 'SCD HISPANIA AZUL A DON TELAS "MASC"',
    logo: '/media/logos/hispania.png',
    category: 'Premini',
    isOwnTeam: false
  },
  {
    id: '992b8582-df61-466c-b05c-83b4e272511f',
    name: 'AGORA PORTALS MIXTO',
    logo: '/media/logos/agora.png',
    category: 'Premini',
    isOwnTeam: false
  },
  {
    id: '411cdc88-37c6-4567-bc6e-49ebecb8640f',
    name: 'JOVENTUT MARIANA GRUPO BAEZA',
    logo: '/media/logos/soller.png',
    category: 'Premini',
    isOwnTeam: false
  },
  {
    id: '52de7773-b2a8-47fe-8b71-1ab37854094d',
    name: 'CB ANDRATX 2016 MARINO MAYANS A',
    logo: '/media/logos/andratx.png',
    category: 'Premini',
    isOwnTeam: false
  },
  {
    id: 'ce6a1ab2-5555-48fe-8549-252ac5b4cefc',
    name: 'CB IMPRENTA BAHIA SAN AGUSTIN MIXTO PALMA A',
    logo: '/media/logos/bahia.png',
    category: 'Premini',
    isOwnTeam: false
  }
];

// Exportar también como teamsData para compatibilidad
export const teamsData = teams;

export const getTeamById = (id: string): TeamData | undefined => {
  return teams.find(team => team.id === id);
};

export const getTeamsByCategory = (category: string, group?: string): TeamData[] => {
  return teams.filter(team => {
    if (group) {
      return team.category === category && team.group === group;
    }
    return team.category === category;
  });
};

export const getOwnTeams = (): TeamData[] => {
  return teams.filter(team => team.isOwnTeam === true || team.isOwn === true || team.type === 'own');
};

export const getRivalTeams = (): TeamData[] => {
  return teams.filter(team => team.isOwnTeam === false || team.isOwnTeam === undefined);
};

export const getTeamsByGroup = (category: string, group: string): TeamData[] => {
  return teams.filter(team => team.category === category && team.group === group);
};
